import React from "react";
import HeroSectionStyle from "../../components/Sections/HeroSectionStyle";
import { Box, Grid } from "@mui/material";
import { APP_COLORS } from "../../utils/constants";

export default function ContactSection({ id }) {
  return (
    <Box
      className="container-fluid"
      sx={{ pt: 11, backgroundColor: APP_COLORS.MAIN }}
    >
      <HeroSectionStyle
        // title="BRING YOUR VISION TO LIFE"
        title={
          <>
            BRING YOUR <br />
            VISION TO LIFE
          </>
        }
        id={id}
        p="We'd love to get a first impression of you, or your business idea - feel free to drop us a line or give us a call."
        colored
      />

      <Box className="container" sx={{ pb: "3.5rem" }}>
        <Grid
          container
          sx={{
            width: "60rem",
            py: 11,
            fontSize: { xs: "1rem", lg: "1.2rem" },
          }}
        >
          <Grid size={{ xs: 12, md: 8 }}>
            <Box sx={{ color: APP_COLORS.MAIN_LIGHT, pb: { xs: 1, lg: 1.5 } }}>
              ADDRESS
            </Box>
            <Box
              sx={{
                color: APP_COLORS.SECONDARY_BACKGROUND,
                lineHeight: 1.4,
                opacity: 0.8,
              }}
            >
              THE POLYGON BUSINESS PARK | POLYGON X
              <br />
              SOUTH TOWER 2-08, SODIC WEST
              <br />
              SHEIKH ZAYED, GIZA, PC. 12588, EGYPT.
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }} sx={{ mt: { xs: "3rem", lg: 0 } }}>
            <Box sx={{ color: APP_COLORS.MAIN_LIGHT, pb: { xs: 1, lg: 1.2 } }}>
              CONTACT
            </Box>
            <Box
              sx={{
                color: APP_COLORS.SECONDARY_BACKGROUND,
                lineHeight: 1.4,
                opacity: 0.8,
              }}
            >
              <Box
                component="a"
                href="mailto:inquiry@rubiconbpe.com?subject=Hello&body=This%20is%20a%20test"
                // target="_blank"
                sx={{
                  color: APP_COLORS.BACKGROUND,
                  lineHeight: 1.4,
                  opacity: 0.8,
                  fontSize: { xs: "1.1rem", lg: "1.4rem" },
                  textDecoration: "underline",
                  px: 0,
                  py: 1,
                  cursor: "pointer",
                }}
              >
                inquiry@rubiconbpe.com
              </Box>
              <br />
              +2(0)12 10 9999 34
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
